/*
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-05 15:05:16
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-05 15:05:48
 * @FilePath: \partner.chaoyongtuan.com\src\views\secondColonelManage\rulesSetting\editRules\js\data.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const tList = [
	{
		anchor_id: '221',
		anchor_name: '小透明',
		anchor_account: 'Blovepupil78',
		anchor_uid: '71052176708',
		head: 'https://p11.douyinpic.com/aweme/720x720/aweme-avatar/tos-cn-avt-0015_a9c3609105872e7e1594fdf214779863.jpeg?from=3067671334',
		fans_num: '1052',
		platform_id: '1',
		partners: [
			{
				anchor_id: '221',
				partner_id: '3',
				partner_role_name: 'yy商务',
				user_id: '1',
			},
			{
				anchor_id: '221',
				partner_id: '5',
				partner_role_name: 'leo商务',
				user_id: '2',
			},
		],
	},
	{
		anchor_id: '95320',
		anchor_name: 'GendQAQ',
		anchor_account: 'GendQAQ',
		anchor_uid: '62429322464',
		head: 'https://p3.douyinpic.com/aweme/720x720/aweme-avatar/tos-cn-i-0813_oA8pnIgHqDAygAekAsA9IkE2bJACWCAC3nV9te.jpeg?from=3067671334',
		fans_num: '36',
		platform_id: '1',
		partners: [
			{
				anchor_id: '95320',
				partner_id: '3',
				partner_role_name: 'yy商务',
				user_id: '1',
			},
			{
				anchor_id: '95320',
				partner_id: '57',
				partner_role_name: '彭',
				user_id: '42',
			},
		],
	},
	{
		anchor_id: '563108',
		anchor_name: '菠菜啵啵啵啵',
		anchor_account: '169448127',
		anchor_uid: '71117124111',
		head: 'https://p26.douyinpic.com/aweme/720x720/aweme-avatar/a6eb0476e22e222afc33f27ff0dc7a50.jpeg?from=3067671334',
		fans_num: 0,
		platform_id: '1',
		partners: [
			{
				anchor_id: '563108',
				partner_id: '3',
				partner_role_name: 'yy商务',
				user_id: '1',
			},
			{
				anchor_id: '563108',
				partner_id: '57',
				partner_role_name: '彭',
				user_id: '42',
			},
		],
	},
];
